import { connect } from "react-redux";
import { getListMauInNhanVay, getNoiDungInNhanVay } from "actions/InNhanVay";
import ModalInHopDong from "../../components/NhanVay/ChucNang/InHopDong/ModalInHopDong";

const mapStateToProps = (state) => ({
  inNhanVay: state.inNhanVay,
});

const mapDispatchToProps = (dispatch) => ({
  getListMauInNhanVay: () => dispatch(getListMauInNhanVay()),
  getNoiDungInNhanVay: (dataSearch) =>
    dispatch(getNoiDungInNhanVay(dataSearch)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalInHopDong);
